import lockScroll from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class MainNav {
	constructor(
		mobileMenuTrigger = '.nav-hamburger',
		megaMenuTrigger = '.main-header__nav > ul > .menu-item-has-children > a, .main-header__nav > ul > .menu-item-has-children > button',
		subNavTrigger = '.main-header__nav .menu-item-has-children > a, .main-header__nav .menu-item-has-children > button',
		searchTrigger = '.main-header__search-button, .block-blog-navigation__search-trigger',
		outsideTrigger = '.main-nav-mega-menu__overlay'
	) {
		this.mobileMenuTrigger = mobileMenuTrigger;
		this.megaMenuTrigger = megaMenuTrigger;
		this.subNavTrigger = subNavTrigger;
		this.searchTrigger = searchTrigger;
		this.outsideTrigger = outsideTrigger;
	}
	init() {
		$(this.mobileMenuTrigger).on('click', this.toggleMobileMenu);
		$(this.subNavTrigger).on('click', (e) => {
			this.toggleSubNav(e);
		});
		$(this.megaMenuTrigger).on('click', (e) => {
			this.toggleMegaMenu(e);
		});
		$(this.searchTrigger).on('click', this.toggleSearch);
		$(this.outsideTrigger).on('click', this.hideOutsideClick);

		const $favoritesButton = document.querySelector(
			'.main-header__favorites'
		);

		const favoriteAdventures = JSON.parse(
			localStorage.getItem('favoriteAdventures')
		);

		if (favoriteAdventures && favoriteAdventures.length !== 0) {
			$favoritesButton.classList.add('main-header__favorites_active');
		}
	}
	setNavHeight() {
		const windowHeight = window.innerHeight;
		const adminBarHeight = document.getElementById('wpadminbar')
			? document.getElementById('wpadminbar').offsetHeight
			: 0;
		const headerHeight =
			document.querySelector('.main-header').offsetHeight;
		const navHeight = windowHeight - adminBarHeight - headerHeight;
		document.documentElement.style.setProperty(
			'--nav-height',
			navHeight + 'px'
		);
	}
	toggleMobileMenu() {
		$('body').removeClass('search-open');

		// document.body.classList.toggle('mobile-menu-open');
		$('body').toggleClass('mobile-menu-open');

		// if (document.body.classList.contains('mobile-menu-open')) {
		if ($('body').hasClass('mobile-menu-open')) {
			lockScroll.lock();
		} else {
			lockScroll.unlock();
		}
	}
	toggleMegaMenu(e) {
		$('body').removeClass('search-open');

		if (1200 <= window.innerWidth) {
			if (
				$('.main-header__nav > ul > .menu-item-has-children').hasClass(
					'open'
				)
			) {
				$('body').addClass('mega-menu-open');
				$('.main-header__nav > ul > .menu-item-has-children.open')
					.find('> ul > li.open')
					.removeClass('open');
				$('.main-header__nav > ul > .menu-item-has-children.open')
					.find('> ul > li:first-child')
					.addClass('open');
				lockScroll.lock();
			} else {
				$('body').removeClass('mega-menu-open');
				lockScroll.unlock();
			}
		}
	}
	toggleSubNav(e) {
		e.preventDefault();
		const $listItem = $(e.target).closest('li');
		if (
			1200 > $(window).width() ||
			!($listItem.hasClass('depth-1') && $listItem.hasClass('open'))
		) {
			$listItem.toggleClass('open');
			$listItem.siblings().removeClass('open');
		}
	}
	toggleSearch() {
		$('body').removeClass('mobile-menu-open');
		$('body').removeClass('mega-menu-open');
		$('.main-header__nav .open').removeClass('open');

		// document.body.classList.toggle('search-open');
		$('body').toggleClass('search-open');

		// if (document.body.classList.contains('search-open')) {
		if ($('body').hasClass('search-open')) {
			$('#s').focus();
			lockScroll.lock();
		} else {
			$('#s').blur();
			lockScroll.unlock();
		}
	}
	hideOutsideClick() {
		$('body').removeClass('mega-menu-open');
		$('body').removeClass('mobile-menu-open');
		$('body').removeClass('search-open');
		$('.main-header__nav .open').removeClass('open');
		lockScroll.unlock();
	}
}

export default new MainNav();
